module.exports = __webpack_public_path__ + "img/2code.d1a41264.png";